module.exports = "/assets/9f34deea9fda40406a67597dcb90a8ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/9R.png
// module id = 1170
// module chunks = 0